var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_48_8647",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_48_8647",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADfklEQVR4nO2ZS2wOURTHf0UfIt60lFgUi1Y3jWgjHolg5ZFKBKmQSMWbJSFih8Su8apadSWepUQQxCMqEQltNUSJV2yUNuqZEiNXziQ3k2/G3Pt9M1+bfP/kbM6998z8Z86c10AGGaQVS4CHwG+gFZhNH0M2cBRwPNIFjKOPYBhwPQEJVy4a2OoBOoEnwBlgJ1AB9CNiFAJtASRcWR3Snt/5d8C+qN5uAfA8BAkln4CxIV10JFAGVAFHgJeanZ/AYWBEqkjkAE0hSbhy3vJaWcAM4IQEEWWrA1iWCiK7DEm4op5yMij2fI+HgAHJGHxtSeSjuKQfNgKLgXIgL2DfBuCH2GwEBtoS+WZJxJFo5Ad93xfgNLAC6J9gb7m4mEvG6s28SIKIE+DfKhddAJqBP9p+FY4X+rhah+w5aEPkXJJEnoa4hgq1m4B27Vx9Aper0NxsqSmR9UkS+W5wLRWSNwPdcvY+kJ/g21JrH4DhJkTytVBoI+pmTDFFyylNQK5n/Yati7kHbcQv038Vt6sD5iVYH62RqfeslcjD/SkVR2hUWpJ4FFA7effeAiZ79pRqbrbAs3ZS9HtNM26LBZG5ATYHSXmyW/zdLW9mefZtlbVWT2ieKfo3poXmckMSKt6HxRDgrEZmkqdEapc1dQ/6w30lepVnQkMdvGtApNrEuDxVl8xNz9oW0Z/y6GtFv8PwWv98tickEdVrFBnaH6q5me6W4yVpdnsi2ErZq6oCYxww/NjVt2CCPXL2mEffIvrpmm6q6NSaMfKkrAhL5or4eViU+VQEjaJf5QnRjpQuVigxLCYbDAq9wVohqcOdE2zTdLmiU/nEGusMo1idBIxeiVpDMjX0UmRLRjYl0yvfTIFFz3Lcp4FKOyYAby0GFEEtbtpQKuWFCZmrPnlGva01MpL9JaE4JZOUsCiXsGlCRuWkiZoNldEfB0wyC+MiM1/iugmZTqnNLoWczlTFRabSgoypNABj4iAzR2uKopIuScyRY5o2wolSLkuFHHk0ex8DmS7TBssGRSkY9Dkh5AExQI2V7kRM5DMxIUcapqiI3CNmrE1yOO74iHdkFAuKpRVOFYka0gjV4e03GGg4AeE3qZ9AqYKa9d62JNEsc7Fegyz5VWDibm3/+SuWdkKLgGtSwjs+okL5KPoI1O/rahlYP5MJvhqTbpc2O4MMSAP+AjPaFo0oVNZuAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.49315b42273b2754dd447f3d5d9cff0e.svg";
export { ForwardRef as ReactComponent };